import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import MetaPixel from "@/components/MetaPixel";
import PostHogAnalytics from "@/components/PostHogAnalytics";
import CookieConsentBanner from "@/components/CookieConsentBanner";
import { CookieConsentProvider } from "@/components/CookieConsentContext";
import SiteFooter from "@/components/SiteFooter";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Landing from "@/pages/Landing";
import Access from "@/pages/Access";
import Pack from "@/pages/Pack";
import Planner from "@/pages/Planner";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import LegalNotice from "@/pages/LegalNotice";
import CookiePolicy from "@/pages/CookiePolicy";
import PurchaseConditions from "@/pages/PurchaseConditions";
import FreeGuide from "@/pages/FreeGuide";
import RabietasWorkshop from "@/pages/RabietasWorkshop";
import ThankYou from "@/pages/ThankYou";
import { AffiliateActivate, AffiliateDashboard, AffiliateJoin, AffiliateLogin, AffiliateTerms } from "@/pages/Affiliates";
import { AffiliateAttribution } from "@/components/affiliate/AffiliateAttribution";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <CookieConsentProvider>
          <MetaPixel />
          <PostHogAnalytics />
          <AffiliateAttribution />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/colabora" element={<AffiliateJoin />} />
            <Route path="/colabora/condiciones" element={<AffiliateTerms />} />
            <Route path="/colabora/activar" element={<AffiliateActivate />} />
            <Route path="/colabora/acceso" element={<AffiliateLogin />} />
            <Route path="/colabora/panel" element={<AffiliateDashboard />} />
            <Route path="/guia-pareja-crianza" element={<FreeGuide />} />
            <Route path="/taller-rabietas-2-3" element={<RabietasWorkshop />} />
            <Route path="/gracias" element={<ThankYou />} />
            <Route path="/acceder" element={<Access />} />
            <Route path="/acceso" element={<Access />} />
            <Route path="/pack" element={<Pack />} />
            <Route path="/pack/planificador/:id" element={<Planner />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/politica-de-privacidad" element={<Privacy />} />
            <Route path="/privacidad" element={<Privacy />} />
            <Route path="/aviso-legal" element={<LegalNotice />} />
            <Route path="/politica-de-cookies" element={<CookiePolicy />} />
            <Route path="/condiciones-de-compra" element={<PurchaseConditions />} />
          </Routes>
          <FloatingWhatsApp />
          <SiteFooter />
          <CookieConsentBanner />
        </CookieConsentProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
